import { Heading, HStack, Link } from '@chakra-ui/react'
import { RightArrowIcon } from '@!/components/Icon'

export const SectionTitle = ({ title, url, gtmClick }) => {
  return (
    <HStack gap={0} mb={3}>
      <Heading fontSize="md" as="h2" lineClamp={1} flex="1">
        {title}
      </Heading>
      {url && (
        <Link
          as="a"
          href={url}
          fontSize="sm"
          fontWeight="300"
          color="label.primary"
          textDecoration="none"
          {...(gtmClick && { 'data-gtm-click': `${gtmClick}_more` })}
        >
          一覧
          <RightArrowIcon ml={0.5} mb={0.5} />
        </Link>
      )}
    </HStack>
  )
}
